export default "__VITE_ASSET__D6gom0yC__"